import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeroImage from "../static/trucks.jpg";
import "./HeroSection.css";

export default function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="hero">
      {/* Background */}
      <div className="hero-bg">
        <img src={HeroImage} alt="Polania Construction" className="hero-bg-image" />
        <div className="hero-overlay"></div>
        <div className="hero-grain"></div>
      </div>

      {/* Content */}
      <div className="hero-content">
        <div className={`hero-text ${isVisible ? 'visible' : ''}`}>
          {/* Heritage Badge */}
          <div className="hero-badge">
            <span className="badge-line"></span>
            <span className="badge-text">POLISH MASONRY TRADITION</span>
            <span className="badge-line"></span>
          </div>

          {/* Main Headline */}
          <h1 className="hero-headline">
            <span className="headline-row">CRAFTING</span>
            <span className="headline-row accent">EXCELLENCE</span>
            <span className="headline-row">SINCE 1985</span>
          </h1>

          {/* Subheadline */}
          <p className="hero-subheadline">
            Four decades of bringing authentic Polish masonry craftsmanship 
            to Central New Jersey. Where old-world techniques meet modern precision.
          </p>

          {/* CTA Buttons */}
          <div className="hero-cta">
            <Link to="/estimate" className="btn-primary">
              GET FREE ESTIMATE
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
            <Link to="/portfolio" className="btn-outline">
              VIEW OUR WORK
            </Link>
          </div>
        </div>

        {/* Stats Bar */}
        <div className={`hero-stats ${isVisible ? 'visible' : ''}`}>
          <div className="stat-item">
            <span className="stat-number">40+</span>
            <span className="stat-label">YEARS OF EXCELLENCE</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-number">2,500+</span>
            <span className="stat-label">PROJECTS COMPLETED</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-number">100%</span>
            <span className="stat-label">SATISFACTION GUARANTEED</span>
          </div>
        </div>
      </div>

      {/* Side Text */}
      <div className="hero-side-text">
        CENTRAL NEW JERSEY
      </div>
    </section>
  );
}
